export const selectUserMails = {
	list: (state) => state.utils.user_mails.list,
	fetch: (state) => state.utils.user_mails.fetch,
	confirmed: (state) => state.utils.user_mails.confirmed,
	countdown: (state) => state.utils.user_mails.countdown,
};
